import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MenuItem } from '../interfaces/menu-item';
import { Apollo } from 'apollo-angular';
import { map, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { Order } from '../interfaces/order';
import { AppsyncService } from './appsync.service';
import 'rxjs/add/observable/from';
import { v4 as uuid } from 'uuid';
import listMenu from '../graphql/queries/listMenu';

import { LoaderService } from '../pages/loader/loader.service';
import { ItonicsAuthService } from './itonicsAuth.service';

@Injectable()
export class MockMenuService {
  constructor(
    protected apollo: Apollo,
    protected appsync: AppsyncService,
    protected itonicsAuthService: ItonicsAuthService,
    protected loaderService: LoaderService
  ) {}

  /* getItems(query: any): Observable<Array<MenuItem>> {
         return this.apollo.query({
             query: query
         }) .pipe(
             map((result: any) => result.data.menu.slice())
         );
     }*/

  getItems(query: any): Observable<Array<MenuItem>> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  getOrderById(id: any, query: any) {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            id: id
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  searchUserList(search: string, query: any) {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            search: search
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  searchItemList(search: string, query: any) {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            search: search
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  /* getOrderById(id: any, query: any): Observable<Array<Order>> {

        console.log("-------------------------->>",query)

        return Observable.from(this.appsync.client.hydrated()).pipe(mergeMap(client => {
            return client['watchQuery']({
                query: query,
                variables: {
                    id: id,
                },
                fetchPolicy: 'network-only'
            });
        }));


        /!*return this.apollo.watchQuery({
            query: query,
            variables: {
                id: id,
            },
        })
            .valueChanges
            .map((result: any) => result.data.getOrder.slice());*!/
    }*/

  getUserOrder(id: any, query: any): Observable<Array<Order>> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            id: id
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  getuserDetail(id: any, query: any): Observable<Array<Order>> {
    return this.apollo
      .watchQuery({
        query: query,
        variables: {
          id: id
        }
      })
      .valueChanges.map((result: any) => result.data.userOrder.slice());
  }

  getOrderByDate(date: number, query: any): Observable<Array<Order>> {
    const queryResult = this.apollo
      .watchQuery({
        query: query,
        variables: {
          date: date
        }
        // pollInterval: 500
      })
      .valueChanges.pipe(map((result: any) => result.data.orderListByDate.slice()));

    return queryResult;
  }

  getUserOrderListByDate(id: string, date: number, query: any): Observable<Array<Order>> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            id: id,
            date: date
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  getItemById(id: any, query: any) {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['watchQuery']({
          query: query,
          variables: {
            id: id
          },
          fetchPolicy: 'network-only'
        });
      })
    );
  }

  deleteItem(id: number, deleteQuery: any): Observable<MenuItem> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['mutate']({
          mutation: deleteQuery,
          variables: {
            id: id
          },
          // optimisticResponse: () => ({deleteMenuItem: {id, __typename: 'MenuItem'}}),
          refetchQueries: [{ query: listMenu }],
          update: (dataProxy, { data: { deleteMenuItem } }) => {
            const query = listMenu;
            const data = dataProxy.readQuery({ query });

            if (deleteMenuItem) {
              data.listMenu = data.listMenu.filter((menu) => menu.id !== deleteMenuItem.id);
              dataProxy.writeQuery({ query, data });
            }
          }
        });
      })
    );
  }

  addEditItem(menuItem: any, addEditQuery: any): Observable<MenuItem> {
    this.showLoader();

    console.log(menuItem);

    if (menuItem.id !== 0 ) {
      return Observable.from(this.appsync.client.hydrated()).pipe(
        mergeMap((client) => {
          return client['mutate']({
            mutation: addEditQuery,
            variables: {
              id: menuItem.id,
              title: menuItem.title,
              price: menuItem.price
            },
            // optimisticResponse: () => ({editMenuItem: {...menuItem, __typename: 'MenuItem', version: 1}}),
            refetchQueries: [{ query: listMenu }],
            update: (dataProxy, { data: { editMenuItem } }) => {
              const query = listMenu;
              const data = dataProxy.readQuery({ query });
              data.listMenu = data.listMenu.map((menu) => (menu.id !== editMenuItem.id ? menu : { ...editMenuItem }));

              dataProxy.writeQuery({ query, data });
            }
          });
        })
      );
    } else {
      menuItem.id = uuid();

      return Observable.from(this.appsync.client.hydrated()).pipe(
        mergeMap((client) => {
          return client['mutate']({
            mutation: addEditQuery,
            variables: {
              id: menuItem.id,
              title: menuItem.title,
              price: menuItem.price,
              picture: '',
              halfAllowed: 1,
              tags: '',
              type: ''
            },
            // optimisticResponse: () => ({addMenuItem: {...menuItem, __typename: 'MenuItem', version: 1}}),
            refetchQueries: [{ query: listMenu }],
            update: (dataProxy, { data: { addMenuItem } }) => {
              const query = listMenu;
              const data = dataProxy.readQuery({ query });

              data.listMenu.push(addMenuItem);

              dataProxy.writeQuery({ query, data });

              /*console.log('addMenuItem current content with:', _menuItem);
                        const options = {
                            query: listMenu
                        };*/

              /*const data = proxy.readQuery(options);
                        let hasBeenAdded = false;
                        data.listMenu.map((item) => {
                            if (item.id === _menuItem.id) {
                                hasBeenAdded = true;
                            }
                        })
                        if (hasBeenAdded) return
                        console.log('addMenuItem update with proxy cache:', data);
                        proxy.writeQuery({query: listMenu, data})*/
            }
          });
        })
      );
    }
  }

  addOrder(order: any, orderQuery: any): Observable<Order> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        this.showLoader();

        if (order.userId === 0) {
          order.userId = this.itonicsAuthService.getCurrentUser()['username'];
        }
        // order.userId = 'someUserId'; // this.itonicsAuthService.getCurrentUser()['username'];
        order.userName = this.itonicsAuthService.getUserDetails(order.userId); // localStorage.getItem('loggedInFullname');

        return client['mutate']({
          mutation: orderQuery,
          variables: {
            id: order.id,
            menuItemId: order.menuItemId,
            userId: order.userId,
            userName: order.userName,
            date: order.date,
            quantity: order.quantity,
            packing: order.packing,
            note: order.note
          }
          // optimisticResponse: () => ({addOrder: {...order, __typename: 'Order'}}),
          /*  update: (proxy, {data: {addOrder: _order}}) => {

                      console.log('addOrder update with:', _order);
                      const options = {
                          query: orderListByDate,
                          variables: {date: _order.date}
                      };

                      const data = proxy.readQuery(options);
                      console.log(data);
                      let hasBeenAdded = false;
                      data.orderListByDate.map((item) => {
                          if (item.id === _order.id) {
                              hasBeenAdded = true;
                          }
                      })
                      if (hasBeenAdded) return
                      data.orderListByDate.push(_order)
                      proxy.writeQuery({query: orderListByDate, data})
                  }*/
        });
      })
    );
  }

  editOrder(order: any, uid: any, orderQuery: any): Observable<Order> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        this.showLoader();
        return client['mutate']({
          mutation: orderQuery,
          variables: {
            id: order.id,
            menuItemId: order.menuItemId,
            userId: order.userId,
            date: order.date,
            quantity: order.quantity,
            packing: order.packing,
            note: order.note
          }
          // optimisticResponse: () => ({editMenuItem: {...order, __typename: 'Order', version: 1}}),
          /* refetchQueries: [{query: listMenu}],
                 update: (dataProxy, {data: {editMenuItem}}) => {
                     const query = listMenu;
                     const data = dataProxy.readQuery({query});

                     console.log("-----");
                     console.log(data.listMenu);

                     data.listMenu = data.listMenu.map(menu => menu.id !== editMenuItem.id ? menu : {...editMenuItem});

                     dataProxy.writeQuery({query, data});
                 }*/
        });
      })
    );
  }

  deleteOrderItem(id: number, deleteOrderItemQuery: any): Observable<MenuItem> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        this.showLoader();
        return client['mutate']({
          mutation: deleteOrderItemQuery,
          variables: {
            id: id
          }
          //   optimisticResponse: () => ({deleteOrderItem: {id, __typename: 'Order'}}),
          /* refetchQueries: [{query: listMenu}],
                 update: (dataProxy, {data: {deleteMenuItem}}) => {
                     const query = listMenu;
                     const data = dataProxy.readQuery({query});

                     if (deleteMenuItem) {
                         data.listMenu = data.listMenu.filter(menu => menu.id !== deleteMenuItem.id);
                         dataProxy.writeQuery({query, data});
                     }
                 }*/
        });
      })
    );
  }

  addEditUser(user: any, addEditQuery: any): Observable<string> {
    return this.apollo
      .mutate({
        mutation: addEditQuery,
        variables: {
          obj: {
            email: user.email,
            firstname: user.firstname,
            lastname: user.lastname,
            password: user.password,
            enabled: 1
          }
        }
      })
      .map((res) => {
        const result: any = res.data;
        return result.signup;
      });
  }

  signIn(email: string, password: string, singInQuery: any): Observable<string> {
    return this.apollo
      .mutate({
        mutation: singInQuery,
        variables: {
          email: email,
          password: password
        }
      })
      .map((res) => {
        const result: any = res.data;
        return result.login;
      });
  }

  deleteOrdersByItemId(id: number, deleteOrderQuery: any): Observable<MenuItem> {
    return Observable.from(this.appsync.client.hydrated()).pipe(
      mergeMap((client) => {
        return client['mutate']({
          mutation: deleteOrderQuery,
          variables: {
            id: id
          }
        });
      })
    );
  }

  protected onEnd(): void {
    this.hideLoader();
  }

  showLoader(): void {
    this.loaderService.show();
  }

  hideLoader(): void {
    this.loaderService.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mock-menu.service.ts